import { Col } from 'bee-layout'

export default Col
